import React, { useState, useEffect, useRef } from 'react';
import { get } from '../../util/request';
import { post } from '../../util/request';
import { put } from '../../util/request';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { userInfo, updateUserInfoFun } from '../../redux/slice';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Select from 'react-select'
import './index.scss'
import Dropdown from 'react-bootstrap/Dropdown';
import { Pagination } from 'antd';
import { useTranslation } from 'react-i18next';
import ExitBanner from '../../components/page/exitBanner/index.js';

const Inbox = () => {
  const { t, i18n } = useTranslation();
  const user = useSelector(userInfo);
  const history = useHistory();

  useEffect(() => {
    const pd = JSON.parse(sessionStorage.getItem('previewDetail'));
    const isClientView = (pd !== null && pd?.sfUserType === 'CL') ||
      (pd === null && user?.sfUserType === 'CL');
    const hasActiveInv = pd !== null ? pd?.hasActiveInvestment : user?.hasActiveInvestment;
    if (isClientView && hasActiveInv === false) {
      history.push(history.location.pathname.startsWith('/preview/') ? '/preview/document' : '/document');
    }
  }, []);

  const filterBoxRef = useRef(null);
  const [listData, setListData] = useState([]);
  const [pageNum, setPageNum] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [isSearchable, setIsSearchable] = useState(false);
  const [keywords, setkeywords] = useState('');
  const [searchDocType, setsearchDocType] = useState({ value: 'All', label: t('All') },)
  const [sort, setSort] = useState(true)

  const [total, setTotal] = useState(0);
  const [showFilterBox, setShowFilterBox] = useState(false);


  const NewOld = () => {
    setSort(true)

  }

  const OldNew = () => {
    setSort(false)
  }

  const keywordsChange = event => {
    setkeywords(event.target.value);
  };
  const options = [
    { value: 'All', label: t('All') },
    { value: 'INVESTMENT', label: t('InvestmentUpdates') },
    { value: 'CORPORATE', label: t('CorporateUpdates') },
    { value: 'MARKET', label: t('MarketUpdates') },
    { value: 'SYSTEM', label: t('SystemUpdates') },
    { value: 'PROFILE', label: t('ProfileUpdates') },
  ]


  const reset = () => {
    setkeywords('')
    // setsearchDocType(t('All'));
    setsearchDocType({ value: 'All', label: t('All') })
    setSort(true)
    setButton(true)

    setResetopen(!resetopen)
    // 关掉Filter Box
    setShowFilterBox(false);
  };
  const [resetopen, setResetopen] = useState(true)
  useEffect(() => {
    init()
  }, [resetopen]);

  const init = async (isRead) => {
    if (!user) {
      return
    }
    const type = options.find(item => item.label == searchDocType)?.value
    let params = {
      offset: "DESC",
      // pageSize: pageSize,
      page: pageNum > 0 ? pageNum - 1 : 0,
      userId: user.userId,
      accessToken: user.accessToken,
      size: pageSize,
      unread: isRead,
      // paged:"",
      // unread: false,
      // unpaged: false,
      type: type == 'All' ? '' : type,
      title: keywords,
      sort: sort ? 'cmsCreatedAt,desc' : 'cmsCreatedAt,aes'
    };
    const data = await get('/notification/list', params);
    if (data) {
      var list = data.content
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      for (var i = 0; i < list?.length; i++) {
        list[i].checked = false
        var time = list[i].deliveryDate
        var month = ''
        var val = null
        if (time.slice(5, 6) == '0') {
          val = time.slice(6, 7)
        } else {
          val = time.slice(5, 7)
        }
        // month = months[val - 1]
        var day = time.slice(8, 10)
        var year = time.slice(0, 4)
        var month = time.slice(5, 7)
        // list[i].deliveryDate = month + ' ' + day + ', ' + year
        list[i].deliveryDate = year + '/' + month + '/' + day
      }
      setListData(list);
      setTotal(data.totalElements);
    }
  };
  const [isShow, setisShow] = useState(false)


  const [isButton, setButton] = useState(true)
  const checkbtn = (isRead) => {
    if (isButton) {
      if (isRead === 'unread') {
        setButton(false);
        init(true);
      } else {
        return
      }
    } else {
      if (isRead === 'overview') {
        setButton(true);
        init(null);
      } else {
        return
      }
    }
    // setButton(!isButton);
    // init(isRead);
  }

  const check = () => {
    setisShow(!isShow)
    var detlist = []
    if (!isShow) {
      for (let i = 0; i < listData.length; i++) {
        listData[i].checked = true
        console.log(listData[i])
        detlist[i] = listData[i].id;

      }
      setDeletelist(detlist)
    } else {
      for (let i = 0; i < listData.length; i++) {
        listData[i].checked = false
      }
      setDeletelist(detlist)
    }


    setListData(listData)
  }

  const sortbtn = (val) => {
    setSort(val)
  }

  useEffect(() => {
    search()
    // alert(sort)
  }, [sort]);

  useEffect(() => {
    init();
  }, [pageNum, pageSize]);



  const [isChecked, setIschecked] = useState(false)
  const [deletelist, setDeletelist] = useState([]);
  const [deletebtn, setDeletebtn] = useState(false)
  useEffect(() => {
    // 在这里可以根据状态变量的值做一些处理
    if (deletelist.length > 0) {

      setDeletebtn(true)
    } else {
      setDeletebtn(false)
    }
  }, [deletelist.length]); // 传入[count]作为第二个参数，表示只有count发生变化时才会执行回调函数

  const deletedata = async () => {
    if (user.sfUserType === 'IR') {
      let params = {
        ids: deletelist,
        userId: user.userId,
        accessToken: user.accessToken,
      };
      const data = await put('/notification/delete', params);
      if (data) {
        window.location.reload()
      }
    }
  }

  const read = async () => {
    let params = {
      userId: user.userId,
      accessToken: user.accessToken,
    };
    const data = await put('/notification/mark-read', params);
    if (!data) {
      console.log(data)
    }

  }

  const overviewData = (id) => {
    setIschecked(!isChecked)
    for (let i = 0; i < listData.length; i++) {
      if (listData[i].id === id) {
        if (!listData[i].checked) {
          listData[i].checked = true
          var addData = deletelist
          addData.push(id)
          setDeletelist(addData)
          console.log(deletelist)
        } else {
          listData[i].checked = false
          var delData = deletelist.filter(item => item != id)
          console.log("=" + delData)
          setDeletelist(delData)
          console.log(deletelist)
        }
      }
    }
    setListData(listData)
    // history.push({
    //   pathname: '/inboxDetails',
    // });

  }


  const goto = (id) => {
    history.push({
      pathname: user.sfUserType === 'IR' ? `/preview/inboxDetails/${id}` : `/inboxDetails/${id}`,
    });
  }

  const search = () => {
    if (isButton) {
      init(null)
    } else {
      init(true)
    }
    // 关掉Filter Box
    setShowFilterBox(false);
  }

  const [filerbtn, setFilerbtn] = useState(true)

  const handleMouseEnterFilterBox = () => {
    setShowFilterBox((prevState) => !prevState);
  };

  const checkfilerbtn = () => {

    if (filerbtn) {
      setFilerbtn(false)
    } else {
      setFilerbtn(true)
    }

  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterBoxRef.current && !filterBoxRef.current.contains(event.target)) {
        setShowFilterBox(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilterBox]);

  //  Filter默认值多语言切换
  useEffect(() => {
    // 添加一个监听器，当语言变化时更新label
    const handleLanguageChange = () => {
      setsearchDocType(prevSortType => ({
        ...prevSortType,
        label: i18n.t('All')
      }));
    };

    // 监听语言变化
    i18n.on('languageChanged', handleLanguageChange);

    // 清理函数，移除监听器
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n])

  useEffect(() => {
    if (user.sfUserType === 'CL' && history.location.pathname.includes('preview')) {
      history.push({
        pathname: '/inbox'
      });
    }
    else if (user.sfUserType === 'IR') {
      history.push({
        pathname: '/preview/inbox'
      });
    }
  }, [])



  return (
    <>
      {
        (user.sfUserType === 'CL' || user.sfUserType === 'IR') && (<>
          <div className='inbox'>
            <div className='main-box'>
              <div className='row'>
                <ExitBanner isMissingProfileBannerOpen={true} isUpdateProfileButtonVisible={true} />
              </div>
              <div className="headline inbox-wrapper">
                <div className='col-md-4 inbox-title'><p>{t('Inbox')}</p></div>
                <div className='col-md-8 inbox-header'></div>
              </div>
              <div className='submit-box'>
                <div className="searchControl">
                  {/* <Form.Control
              type="text"
              placeholder="Keywords"
              id="searchInput"
            />{' '} */}

                  <input value={keywords} onChange={keywordsChange} className="form-control" type="text" placeholder={t("Keywords")} aria-label="search input"></input>
                  <div className="search-box">
                    <button onClick={() => search()} type="button" className="searchBtn btn btn-outline-theme">{t('Search')}</button>
                    <button onClick={() => {
                      reset()
                    }}
                      type="button" className="linkBtn btn btn-link-theme clear-btn">{t('Clear')}</button>
                  </div>
                </div>
                <div className="right-box ">
                  <div className='filterSortby'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 22" fill="none">
                      <path d="M4.2116 5.61C6.2316 8.2 9.9616 13 9.9616 13V19C9.9616 19.55 10.4116 20 10.9616 20H12.9616C13.5116 20 13.9616 19.55 13.9616 19V13C13.9616 13 17.6816 8.2 19.7016 5.61C20.2116 4.95 19.7416 4 18.9116 4H5.0016C4.1716 4 3.7016 4.95 4.2116 5.61Z" fill="#003448" />
                    </svg>
                    {/* <button type="button" onClick={() => checkfilerbtn()} className="linkBtn btn btn-link-theme ">Filter</button>
              <div className={(filerbtn ? 'notification none' : 'notification block')}> */}

                    <button type="button" className=" linkBtn btn btn-link-theme" onClick={handleMouseEnterFilterBox}>{t('Filter')}</button>
                    {
                      showFilterBox ?
                        <div className='notification' ref={filterBoxRef}>
                          <div className="arrows"></div>
                          <div className='filterBox'>
                            <div className="noumenon">
                              {t('Notification Type')}
                              <Select
                                isSearchable={isSearchable}
                                options={options}
                                value={searchDocType}
                                placeholder={searchDocType}
                                onChange={(data) => {
                                  setsearchDocType(data.label);
                                }}

                                theme={(theme) => ({
                                  ...theme,
                                  borderRadius: 5,
                                  colors: {
                                    ...theme.colors,
                                    primary25: '#F5F7FA',
                                    primary: '#003448',
                                  },
                                })}
                              />

                              <div className='btn-box'>
                                <button onClick={() => reset()} type="button" className="ResetBtn btn btn-outline-theme">{t('Reset')}</button>
                                <button onClick={() => search()} type="button" className="ApplyBtn btn btn-outline-next">{t('Apply')}</button>
                              </div>
                            </div>
                          </div>
                        </div> : null
                    }
                    {/* <Dropdown className='NewOld' drop='down-centered'>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 22" fill="none">
                  <path d="M4.2116 5.61C6.2316 8.2 9.9616 13 9.9616 13V19C9.9616 19.55 10.4116 20 10.9616 20H12.9616C13.5116 20 13.9616 19.55 13.9616 19V13C13.9616 13 17.6816 8.2 19.7016 5.61C20.2116 4.95 19.7416 4 18.9116 4H5.0016C4.1716 4 3.7016 4.95 4.2116 5.61Z" fill="#003448" />
                </svg>
                <Dropdown.Toggle className='filter btn-link-theme' id="dropdown-basic">
                  Filter
                </Dropdown.Toggle>


                <Dropdown.Menu className='noumenon'>
                  <div className="arrows"></div>
                  <div className="relative"></div>
                  Notification Type
                  <Select
                    isSearchable={isSearchable}
                    options={options}
                    onChange={(data) => { setsearchDocType(data.value) }}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 5,
                      colors: {
                        ...theme.colors,
                        primary25: '#F5F7FA',
                        primary: '#003448',
                      },
                    })}
                  />

                  <div className='btn-box'>
                    <button onClick={() => reset()} type="button" className="ResetBtn btn btn-outline-theme">Reset</button>
                    <button onClick={() => search()} type="button" className="ApplyBtn btn btn-outline-next">Apply</button>
                  </div>

                </Dropdown.Menu>
              </Dropdown> */}


                    <div className="fly-mid"></div>

                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.35766 16.7616H10.0979C10.1826 16.7616 10.252 16.7888 10.3064 16.843C10.3606 16.8977 10.3879 16.967 10.3879 17.052C10.3879 17.1241 10.3578 17.1969 10.2972 17.2692L7.40594 20.1606C7.34556 20.2148 7.27601 20.2419 7.19747 20.2419C7.12489 20.2419 7.05547 20.2148 6.98899 20.1606L4.08864 17.2601C3.9981 17.1634 3.97683 17.0577 4.02524 16.9428C4.07362 16.822 4.16429 16.7616 4.29712 16.7616H6.03737V4.29C6.03737 4.20549 6.06464 4.13597 6.11889 4.08152C6.17321 4.02714 6.24283 4 6.32737 4H8.06762C8.15229 4 8.22172 4.02727 8.27613 4.08156C8.33055 4.13587 8.35766 4.20549 8.35766 4.29003V16.7616ZM12.1283 6.32029H14.4485C14.5331 6.32029 14.6026 6.29314 14.6568 6.23876C14.7114 6.18435 14.7382 6.11492 14.7382 6.03029V4.29003C14.7382 4.20549 14.7113 4.13597 14.6568 4.08156C14.6026 4.02727 14.5331 4 14.4485 4H12.1283C12.0436 4 11.9742 4.02714 11.9198 4.08152C11.8655 4.13597 11.8383 4.20549 11.8383 4.29V6.03025C11.8383 6.11489 11.8654 6.18432 11.9198 6.23873C11.9742 6.29302 12.0436 6.32029 12.1283 6.32029ZM12.1282 10.961H16.1887C16.2733 10.961 16.3428 10.9338 16.397 10.8794C16.4515 10.825 16.4787 10.7556 16.4787 10.6709V8.93073C16.4787 8.84606 16.4515 8.77663 16.397 8.72225C16.3428 8.66794 16.2733 8.64067 16.1887 8.64067H12.1282C12.0435 8.64067 11.9741 8.66781 11.9197 8.72225C11.8654 8.77663 11.8382 8.84606 11.8382 8.93073V10.6709C11.8382 10.7556 11.8653 10.825 11.9197 10.8794C11.9741 10.9337 12.0435 10.961 12.1282 10.961ZM19.8777 18.0035C19.8232 17.9489 19.7538 17.9218 19.6692 17.9218H12.1283C12.0436 17.9218 11.9742 17.9489 11.9198 18.0035C11.8655 18.0578 11.8383 18.1273 11.8383 18.2118V19.952C11.8383 20.0369 11.8654 20.1061 11.9198 20.1606C11.9742 20.2149 12.0436 20.2421 12.1283 20.2421H19.6692C19.7538 20.2421 19.8232 20.2149 19.8777 20.1606C19.932 20.106 19.9591 20.0369 19.9591 19.952V18.2118C19.9592 18.1273 19.932 18.0578 19.8777 18.0035ZM17.929 15.6014H12.1282C12.0435 15.6014 11.9741 15.5743 11.9197 15.52C11.8653 15.4657 11.8382 15.3961 11.8382 15.3116V13.5712C11.8382 13.4867 11.8654 13.4172 11.9197 13.3629C11.9741 13.3085 12.0435 13.2814 12.1282 13.2814H17.929C18.0135 13.2814 18.083 13.3085 18.1376 13.3629C18.1918 13.4171 18.2189 13.4867 18.2189 13.5712V15.3116C18.2189 15.3961 18.1918 15.4657 18.1376 15.52C18.0831 15.5743 18.0135 15.6014 17.929 15.6014Z" fill="#003448" />
                    </svg>
                    <button type="button" className="linkBtn btn btn-link-theme ">{t('Sort By')}</button>

                    <div className='Sort-box block'>
                      <div className="arrows"></div>
                      <div className='Sort'>
                        <ui>
                          <li onClick={() => NewOld()}>{t('Notification date (New - Old)')}</li>
                          <li onClick={() => OldNew()}>{t('Notification date (Old - New)')}</li>
                        </ui>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='list-box'>
                <div className='tabs-box d-flex'>
                  {isShow ?
                    <div className='unselected clickBtn pointer' onClick={() => check()}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="12" fill="#5582A0" />
                        <path d="M6 12H19" stroke="white" stroke-width="2" stroke-linecap="round" />
                      </svg>
                    </div>
                    :
                    <div className='null clickBtn pointer' onClick={() => check()}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="12" fill="#F1EEEA" />
                      </svg>
                    </div>
                  }
                  <div className='tabs d-flex align-items-center}'>
                    <div className={(isButton ? 'checked-box' : 'unselected-box')} onClick={() => checkbtn('overview')}>
                      <p className={(isButton ? 'checked' : 'unselected')}>{t('Overview')}</p>
                    </div>
                    <div className={(isButton ? 'unselected-box' : 'checked-box')} onClick={() => checkbtn('unread')}>
                      <p className={(isButton ? 'unselected' : 'checked')}>{t('Unread')}</p>
                    </div>
                  </div>
                  {
                    deletebtn && (<>
                      <div className={user.sfUserType === 'IR' ? 'deletebtn-disable' : 'pointer'} onClick={() => deletedata()}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.52734 8.93701H4.84259L6.37006 20.5415C6.40458 20.8039 6.62825 21 6.8929 21H16.1086C16.3732 21 16.5969 20.8039 16.6314 20.5415L18.1589 8.93701H18.4741C18.7654 8.93701 19.0015 8.7009 19.0015 8.40967V6.1024C19.0015 5.81116 18.7654 5.57505 18.4741 5.57505H13.9616V5.36725C13.9616 4.06196 12.8996 3 11.5943 3H11.4071C10.1019 3 9.03989 4.06196 9.03989 5.36725V5.57505H4.52734C4.23611 5.57505 4 5.81116 4 6.1024V8.40967C4 8.7009 4.23607 8.93701 4.52734 8.93701ZM15.6461 19.9453H7.35535L5.90638 8.93701H17.0951L15.6461 19.9453ZM11.4071 4.05469C10.6834 4.05469 10.0945 4.64352 10.0945 5.36725V5.57505H12.9069V5.36725C12.9069 4.64352 12.318 4.05469 11.5943 4.05469H11.4071ZM5.05469 6.62974H17.9468V7.88232H5.05469V6.62974ZM9.17184 18.5065C8.88254 18.534 8.62466 18.3216 8.59724 18.0311L7.92864 10.9503C7.90125 10.6604 8.11409 10.4031 8.40406 10.3757C8.69448 10.3483 8.95127 10.5612 8.97865 10.8512L9.64725 17.9319C9.67464 18.2219 9.4618 18.4792 9.17184 18.5065ZM12.0281 17.9816C12.0281 18.2728 11.792 18.5089 11.5007 18.5089C11.2095 18.5089 10.9734 18.2728 10.9734 17.9816V10.9008C10.9734 10.6095 11.2095 10.3734 11.5007 10.3734C11.792 10.3734 12.0281 10.6095 12.0281 10.9008V17.9816ZM13.8296 18.5066C14.1192 18.534 14.3768 18.3213 14.4042 18.0312L15.0728 10.9504C15.1002 10.6604 14.8873 10.4032 14.5974 10.3758C14.307 10.3482 14.0502 10.5613 14.0228 10.8512L13.3542 17.932C13.3268 18.2219 13.5397 18.4792 13.8296 18.5066Z" fill="#003448" />
                        </svg>
                      </div>
                    </>)
                  }
                </div>
                {isButton ?
                  <div className='card-box'>
                    {listData.map((item) => (
                      <div className='list d-flex' key={item.id} >
                        <div className='list-click d-flex align-items-center'>
                          {item.checked ?
                            <div className='unselected clickBtn pointer' onClick={() => overviewData(item.id)}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <circle cx="12" cy="12" r="12" fill="#5582A0" />
                                <path d="M18.7219 8.31595C18.3373 7.91041 17.6961 7.89255 17.2899 8.27813L10.8231 14.411L7.73857 11.2441C7.34791 10.8433 6.70738 10.8345 6.30623 11.2252C5.90542 11.6156 5.89698 12.2568 6.2873 12.6576L10.0691 16.5403C10.2673 16.7439 10.5306 16.8466 10.7947 16.8466C11.0453 16.8466 11.2958 16.754 11.492 16.5687L18.6841 9.748C19.0899 9.36305 19.1071 8.72184 18.7219 8.31595Z" fill="white" />
                              </svg>
                            </div>
                            :
                            <div className='null clickBtn pointer' onClick={() => overviewData(item.id)}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <circle cx="12" cy="12" r="12" fill="#F1EEEA" />
                              </svg>
                            </div>
                          }
                        </div>

                        <div className={(item.checked ? 'list-card selectCard' : 'list-card notcard')} onClick={() => goto(item.id,)}>
                          <div className='label userSelect'>
                            <span>{item.type}</span>
                            {item.isRead ?
                              <div></div>
                              :
                              <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                  <circle cx="5" cy="5" r="5" fill="#FFC81C" />
                                </svg>
                              </div>
                            }
                          </div>
                          <div className='content'>
                            <p>{item.title}</p>
                          </div>
                          <div className='time'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 17" fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00016 1.83398C4.32394 1.83398 1.3335 4.82443 1.3335 8.50065C1.3335 12.1769 4.32394 15.1673 8.00016 15.1673C11.6764 15.1673 14.6668 12.1769 14.6668 8.50065C14.6668 4.82443 11.6764 1.83398 8.00016 1.83398ZM8.00016 14.1345C4.89404 14.1345 2.36628 11.6068 2.36628 8.50065C2.36628 5.39453 4.89404 2.86677 8.00016 2.86677C11.1068 2.86677 13.634 5.39453 13.634 8.50065C13.634 11.6068 11.1063 14.1345 8.00016 14.1345ZM8.51654 8.28375L10.3756 9.67802C10.6038 9.84896 10.6503 10.1727 10.4788 10.4005C10.3776 10.5368 10.2227 10.6076 10.0652 10.6076C9.95727 10.6076 9.84881 10.574 9.75587 10.5043L7.69029 8.9551C7.56016 8.85802 7.48373 8.70464 7.48373 8.54198V5.44359C7.48373 5.15802 7.71456 4.92719 8.00014 4.92719C8.28571 4.92719 8.51654 5.15802 8.51654 5.44359V8.28375Z" fill="#5582A0" />
                            </svg>
                            <span className="m-l-5">{item.deliveryDate}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  :
                  <div className='card-box'>
                    {listData.map((item) => (
                      <div className='list d-flex' key={item.id}>
                        <div className='list-click d-flex align-items-center'>
                          {item.checked ?
                            <div className='unselected clickBtn pointer' onClick={() => overviewData(item.id)}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <circle cx="12" cy="12" r="12" fill="#5582A0" />
                                <path d="M18.7219 8.31595C18.3373 7.91041 17.6961 7.89255 17.2899 8.27813L10.8231 14.411L7.73857 11.2441C7.34791 10.8433 6.70738 10.8345 6.30623 11.2252C5.90542 11.6156 5.89698 12.2568 6.2873 12.6576L10.0691 16.5403C10.2673 16.7439 10.5306 16.8466 10.7947 16.8466C11.0453 16.8466 11.2958 16.754 11.492 16.5687L18.6841 9.748C19.0899 9.36305 19.1071 8.72184 18.7219 8.31595Z" fill="white" />
                              </svg>
                            </div>
                            :
                            <div className='null clickBtn pointer' onClick={() => overviewData(item.id)}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <circle cx="12" cy="12" r="12" fill="#F1EEEA" />
                              </svg>
                            </div>
                          }
                        </div>
                        <div className={(item.checked ? 'list-card selectCard' : 'list-card notcard')} onClick={() => goto(item.id,)}>
                          <div className='label userSelect'>
                            <span>{item.type}</span>
                            {item.isRead ?
                              <div></div>
                              :
                              <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                  <circle cx="5" cy="5" r="5" fill="#FFC81C" />
                                </svg>
                              </div>
                            }
                          </div>
                          <div className='content'>
                            <p>{item.title}</p>
                          </div>
                          <div className='time'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 17" fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00016 1.83398C4.32394 1.83398 1.3335 4.82443 1.3335 8.50065C1.3335 12.1769 4.32394 15.1673 8.00016 15.1673C11.6764 15.1673 14.6668 12.1769 14.6668 8.50065C14.6668 4.82443 11.6764 1.83398 8.00016 1.83398ZM8.00016 14.1345C4.89404 14.1345 2.36628 11.6068 2.36628 8.50065C2.36628 5.39453 4.89404 2.86677 8.00016 2.86677C11.1068 2.86677 13.634 5.39453 13.634 8.50065C13.634 11.6068 11.1063 14.1345 8.00016 14.1345ZM8.51654 8.28375L10.3756 9.67802C10.6038 9.84896 10.6503 10.1727 10.4788 10.4005C10.3776 10.5368 10.2227 10.6076 10.0652 10.6076C9.95727 10.6076 9.84881 10.574 9.75587 10.5043L7.69029 8.9551C7.56016 8.85802 7.48373 8.70464 7.48373 8.54198V5.44359C7.48373 5.15802 7.71456 4.92719 8.00014 4.92719C8.28571 4.92719 8.51654 5.15802 8.51654 5.44359V8.28375Z" fill="#5582A0" />
                            </svg>
                            <span className="m-l-5">{item.deliveryDate}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                }



              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Pagination
                  total={total}
                  showSizeChanger
                  showQuickJumper
                  pageSize={pageSize}
                  pageSizeOptions={[10, 20, 50, 100]}
                  onChange={(page, pageSize) => {
                    setPageNum(page);
                    // setPageSize(pageSize);
                  }}
                  onShowSizeChange={(current, size) => {
                    setPageSize(size);
                  }}
                  showTotal={(total) => `${t("Total")} ${total} ${t("items")}`}
                />
              </div>

            </div>

          </div >
        </>)
      }
    </>
  );
};
export default Inbox;
